module.exports = __webpack_public_path__ + "bd3cb4fe39068430cc1fe27981791839.svg";